import { openSalesIQChat } from '../utils/openSalesIQChat';
import CallButton from './CallButton';

export default function CtaBanner({
  kicker = 'Ready when you are',
  title = 'Get Family Tree Maker help now',
  text = 'Installation, migration, sync, and TreeVault questions—call or chat for clear next steps.',
  buttonLabel = 'Start Live Chat',
  variant = 'green',
}) {
  const isGreen = variant === 'green';

  return (
    <section className={`t7-section ${isGreen ? 't7-section--green' : 't7-section--wash'}`}>
      <div className="container">
        <div className="t7-cta-row">
          <div>
            <p className="t7-kicker">{kicker}</p>
            <h2
              className="t7-title"
              style={{ color: isGreen ? undefined : '#14201a' }}
            >
              {title}
            </h2>
            <p className={`t7-lead mb-0 ${isGreen ? '' : 'text-[#4d5c54]'}`}>{text}</p>
          </div>
          <div className="t7-cta-row__action">
            <CallButton className={`t7-btn ${isGreen ? 't7-btn--solid' : 't7-btn--green'}`} />
            <button
              type="button"
              className={`t7-btn ${isGreen ? 't7-btn--outline' : 't7-btn--outline-dark'}`}
              onClick={openSalesIQChat}
            >
              {buttonLabel}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
